export const violin = {
  line: {
    width: 0
  }
}



// WEBPACK FOOTER //
// ./src/types/violin.js